<template>
  <CRow>
    <CCol col="12" lg="12" style="margin-bottom: 20px;">
        <button class="btn btn-info" @click="$router.go(-1)">Retour</button>
    </Ccol>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            Ajouter une marque
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>

            <CInput label="Titre" type="text" placeholder="Nom du marque" v-model="product.title"></CInput>

          <CButton color="success" @click="store()" class="w-100">Ajouter</CButton>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            Logo du marque
          </h3>

          <file-upload ref="upload" v-model="files" :drop="true" accept="image/*">
            <CButton class="w-100 btn-primary">Ajouter un logo</CButton>
          </file-upload>

          <div>
            <div :key="file.name" v-for="file in files" class="text-center product-preview" :style="'background-image: url('+getFilePath(file)+')' ">
              <span @click="removePhoto(file)"><CIcon name="cil-x-circle" class="text-danger float-left" height="24"/> </span>
            </div>
          </div>


        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

  import {
    brandService,
  } from "../../_services";
export default {
  name: 'EditUser',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
        files: [],
        product: {
          title: '',
        },
        product_types: [],
        batches: [],
        colors: [],
        sizes: [],
        brands: [],
       
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        product_types_full: []
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    store() {
      this.loader = this.$loading.show();
      let form = new FormData();
      form.append('title', this.product.title);
      this.files.map(function(obj) { form.append('files[]', obj.file); });

      brandService.create(form).then(function (data) {
        this.$toast.success('Marque créé avec succès');
        this.message = "added successfully";
        this.showAlert();
        this.goBack();
      }.bind(this)).finally(function () {
        this.loader.hide();
      }.bind(this))
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getFilePath(file){
      file.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(file.file)
      }
      console.log(this.files.map(function(obj) { return obj.file; }));
      return file.blob;
    },
    removePhoto(file){
      this.files.forEach(function(item, i){
        if(this.files[i].name === file.name) {
          this.files.splice(i,1);
          return false;
        }
      }.bind(this));
    },
  },
  mounted(){
  }
}

</script>
<style>
  .product-preview {
    width: 150px;
    height: 150px;
    float: left;
    background-position: center;
    background-size: 80% 100%;
    background-repeat: no-repeat;
    margin: 5px;
  }
  select{
    width: 100%;
    height: 25px;
    border: 1px solid #ddd;
    padding-left: 10px;
    border-radius: 5px;
    color: #888;
  }
</style>